'use client';

import { ErrorPage } from '@/lib/page-modules/errorPage';

export default function Error({ error, reset }) {
    return <ErrorPage lang="en" error={error} reset={reset} />;
}
